import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
function Forms(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#788590' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.718 11.895l2.756 2.756L12.124 22H9.368v-2.756l7.35-7.35zM16.258 2c1.108 0 2.023.875 2.1 1.974l.006.151v4.239l-2.728 2.499v-1.59H4.727v1.818l10.661-.001-1.984 1.819H4.727v1.818h6.693l-3.965 3.637h-3.35c-1.107 0-2.022-.875-2.1-1.974L2 16.239V4.125c0-1.118.867-2.041 1.955-2.12L4.105 2h12.153zm2.906 7.574a.699.699 0 01.99 0l1.64 1.641a.699.699 0 010 .99l-1.374 1.374-2.63-2.63zm-3.528-3.938H4.727v1.819h10.91V5.636z",
    fill: color,
    fillRule: "evenodd"
  }));
}
export default Forms;